// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ChatPage.test.tsx
export function AskV2ThreadLoading() {
  return (
    <div
      className="space-y-4"
      data-testid="ask-v2-thread-loading"
      aria-busy="true"
    >
      {[1, 2, 3].map((index) => (
        <div
          key={index}
          className="h-16 animate-pulse rounded-lg bg-puntt-neutral-gray-4"
        />
      ))}
    </div>
  );
}
